import { render, staticRenderFns } from "./daichengjiao.vue?vue&type=template&id=6e4c015a&scoped=true"
import script from "./daichengjiao.vue?vue&type=script&lang=js"
export * from "./daichengjiao.vue?vue&type=script&lang=js"
import style0 from "./daichengjiao.vue?vue&type=style&index=0&id=6e4c015a&prod&lang=scss&scoped=true"
import style1 from "./daichengjiao.vue?vue&type=style&index=1&id=6e4c015a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c015a",
  null
  
)

export default component.exports